import { useDispatch, useSelector } from 'react-redux';
import './css/app.css';
import './css/main.css';
import './css/common.css';
import './css/payment.css';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { LoadingModal, MessageModal } from './component/modal/modal';

function SmsAuthPayment() {
    const dispatch = useDispatch();
    const MyData = useSelector((state) => state.MyData);
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState({ msg: "" });
    const [isSubmitting, setIsSubmitting] = useState(false);

    // 폼 데이터
    const [formData, setFormData] = useState({
        productName: "",
        amount: "",
        phoneNumber: "",
    });

    // 전화번호 표시용 (010-1234-5678 형식)
    const [phoneDisplayValue, setPhoneDisplayValue] = useState("");

    useEffect(() => {
        // 권한 체크
        if (MyData.smsConfirm !== 1) {
            setMessage({ msg: "SMS인증결제 권한이 없습니다." });
            setTimeout(() => {
                navigate("/dashboard");
            }, 2000);
            return;
        }

        dispatch(change_Current_Location("SMS인증결제"));
        dispatch(changeHeaderTitle({ mainTitle: "SMS인증결제", subTitle: "" }));
        const t = setTimeout(() => setLoading(false), 300);
        return () => clearTimeout(t);
    }, [dispatch, MyData.smsConfirm, navigate]);

    // 전화번호 입력 핸들러 (010-1234-5678 형식)
    const handlePhoneChange = (e) => {
        let numeric = e.target.value.replace(/\D/g, "").slice(0, 11);
        const parts =
            numeric.length < 4
                ? [numeric]
                : numeric.length < 8
                    ? [numeric.slice(0, 3), numeric.slice(3)]
                    : [numeric.slice(0, 3), numeric.slice(3, 7), numeric.slice(7)];
        const displayVal = parts.join("-");
        setPhoneDisplayValue(displayVal);
        setFormData((prev) => ({ ...prev, phoneNumber: numeric }));
    };

    // 금액 입력 핸들러 (숫자만, 콤마 표시)
    const handleAmountChange = (e) => {
        const numeric = e.target.value.replace(/\D/g, "");
        setFormData((prev) => ({ ...prev, amount: numeric }));
    };

    // 일반 input 핸들러
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // 금액 표시용 (천단위 콤마)
    const displayAmount = formData.amount ? parseInt(formData.amount, 10).toLocaleString("ko-KR") : "";

    // 필수값 체크
    const requiredFilled =
        (formData.productName || "").trim() !== "" &&
        (formData.amount || "").trim() !== "" &&
        formData.amount !== "0" &&
        (formData.phoneNumber || "").trim() !== "" &&
        formData.phoneNumber.length >= 10;

    const isDisabled = isSubmitting || !requiredFilled;

    // URL 생성 및 SMS 전송 (서버에서 처리)
    const handleSendSms = async () => {
        if (isDisabled) return;
        setIsSubmitting(true);
        setLoading(true);

        try {
            // 서버에 상품명, 금액, 전화번호 전송
            // 서버에서 상품 생성, URL 생성, SMS 전송을 모두 처리
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/sms-payment/send",
                {
                    mid: MyData.mid || "",
                    amount: parseInt(formData.amount, 10),
                    productName: formData.productName,
                    phone: formData.phoneNumber.replace(/[^0-9]/g, ''),
                    callback: process.env.REACT_APP_SMS_CALLBACK_NUMBER || "0319908587",
                    identity: true // SMS인증결제는 본인인증 필요
                },
                { withCredentials: true }
            );

            // 새로운 응답 형식 처리
            if (response.data?.success === true && response.data?.data?.smsResponse?.code === "200") {
                setMessage({ msg: "SMS가 전송되었습니다." });
                // 폼 초기화
                setFormData({
                    productName: "",
                    amount: "",
                    phoneNumber: "",
                });
                setPhoneDisplayValue("");
            } else {
                const errorMsg = response.data?.data?.smsResponse?.message 
                    || response.data?.msg 
                    || "SMS 전송에 실패했습니다.";
                throw new Error(errorMsg);
            }
        } catch (error) {
            console.error("SMS 전송 오류:", error);
            const errorMsg = error?.response?.data?.msg || error?.message || "SMS 전송 중 오류가 발생했습니다.";
            setMessage({ msg: errorMsg });
        } finally {
            setLoading(false);
            setIsSubmitting(false);
        }
    };

    return (
        <>
            {loading ? <LoadingModal /> : null}
            <MessageModal message={message} />

            <div style={{ marginTop: '3.5rem', minHeight: 'calc(100dvh - 3.5rem)', background: "#f3f5f7" }}>
                <div className="urlPayment-wrap">
                    <section className="urlPayment-section">
                        <h2 className="urlPayment-title">SMS인증결제 정보 입력</h2>
                        <div className="urlPayment-card">
                            <div className="urlPayment-row">
                                <label className="urlPayment-label">상품명</label>
                                <input
                                    name="productName"
                                    className="urlPayment-input"
                                    placeholder="상품명을 입력하세요"
                                    value={formData.productName}
                                    onChange={handleChange}
                                    maxLength={100}
                                />
                            </div>

                            <div className="urlPayment-row">
                                <label className="urlPayment-label">결제금액</label>
                                <div style={{ display: 'flex', gap: 8, alignItems: 'center', flex: 1 }}>
                                    <input
                                        name="amount"
                                        className="urlPayment-input"
                                        placeholder="금액을 입력하세요"
                                        value={displayAmount}
                                        onChange={handleAmountChange}
                                        style={{ flex: 1 }}
                                    />
                                    <span style={{ fontSize: '14px', color: '#666', whiteSpace: 'nowrap' }}>원</span>
                                </div>
                            </div>

                            <div className="urlPayment-row">
                                <label className="urlPayment-label">전화번호</label>
                                <input
                                    name="phoneNumber_display"
                                    className="urlPayment-input"
                                    placeholder="010-0000-0000"
                                    value={phoneDisplayValue}
                                    onChange={handlePhoneChange}
                                />
                            </div>
                        </div>
                    </section>

                    {/* 안내 메시지 */}
                    <div style={{
                        backgroundColor: '#e8f5e9',
                        border: '1px solid #4caf50',
                        borderRadius: '8px',
                        padding: '12px 16px',
                        margin: '16px 0',
                        fontSize: '14px',
                        color: '#2e7d32'
                    }}>
                        <strong>SMS인증결제 안내</strong><br/>
                        상품명, 결제금액, 전화번호를 입력하시면 인증결제 링크가 포함된 SMS가 전송됩니다.
                    </div>

                    {/* 하단 버튼 공간 확보 */}
                    <div className="urlPayment-bottomPad" />
                </div>

                {/* 하단 고정 버튼 */}
                <div className="urlPayment-buybar">
                    <button
                        className="urlPayment-buyBtn"
                        onClick={handleSendSms}
                        disabled={isDisabled}
                    >
                        {isSubmitting ? "전송중..." : "SMS 전송하기"}
                    </button>
                </div>
            </div>
        </>
    );
}

export default SmsAuthPayment;

